import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { authenticatedRoute } from '../../../pages/AuthenticatedView.route';

export const deduplicationRoute = createRoute({
    getParentRoute: () => authenticatedRoute,
    path: "/reviews/$reviewId/deduplication",
    component: lazyRouteComponent(() => import('./Deduplication.page'))
});
